import { numberFormat, numberWidth } from '@/views/mped/services/mped-columns-service';


export const columnsMoveMainAsset = (lookupList) => {
  const columns = [{
    dataField: 'id',
    caption: 'id',
    dataType: 'number',
    width: '100px',
    visible: false,
    allowEditing: false,
  }, {
    dataField: 'department_id',
    caption: 'department_id',
    dataType: 'number',
    width: '100px',
    visible: false,
    allowEditing: false,
  }, {
    dataField: 'main_asset_id',
    caption: 'main_asset_id',
    dataType: 'number',
    width: '100px',
    visible: false,
    allowEditing: false,
  },
    {
      dataField: 'department',
      caption: 'Подразделение',
      dataType: 'string',
      width: '100px',
      allowEditing: false,
    }, {
      dataField: 'inventory_number',
      caption: 'Инвентарный номер',
      dataType: 'string',
      width: '150px',
      allowEditing: false,
    }, {
      dataField: 'main_asset',
      caption: '№ основного ср-ва',
      dataType: 'string',
      width: '150px',
      allowEditing: false,
    }, {
      dataField: 'subnumber',
      caption: 'Субномер',
      dataType: 'number',
      width: '80px',
      allowEditing: false,
    }, {
      dataField: 'name',
      caption: 'Наименование',
      dataType: 'string',
      allowEditing: false,
      minWidth: 250,
    }, {
      dataField: 'group_amortization',
      caption: 'Гр. ам-и',
      dataType: 'string',
      width: '80px',
      allowEditing: false,
    }, {
      dataField: 'date_operation',
      caption: 'Дата операции',
      dataType: 'date',
      width: '100px',
      allowEditing: true,
      validationRules: {
        type: 'required',
        message: 'Обязательное полея для заполнения',
      },
    }, {
      dataField: 'period',
      caption: 'Период загрузки',
      dataType: 'string',
      width: '100px',
      lookup: lookupList.periodList,
      allowEditing: true,
    }, {
      dataField: 'value_operation',
      caption: 'Сумма',
      dataType: 'number',
      width: numberWidth,
      format: numberFormat,
      allowEditing: true,
    }, {
      dataField: 'cause_id',
      caption: 'Причина изменения стоимости',
      width: '120px',
      lookup: lookupList.causeList,
      allowEditing: true,
    }, {
      dataField: 'without_date',
      caption: 'Без даты',
      dataType: 'boolean',
      width: '90px',
      allowEditing: false,
    }, {
      dataField: 'future_date',
      caption: 'Дата будущего периода',
      dataType: 'boolean',
      width: '90px',
      allowEditing: false,
    }, {
      dataField: 'useful_life_accounting',
      caption: 'СПИ по бух.учету',
      dataType: 'number',
      width: 100,
      allowEditing: true,
      editorOptions: {
        onKeyPress: editInteger,
      },
    }, {
      dataField: 'residual_value_accounting',
      caption: 'Остаточная стоимость по  бух.учету',
      format: numberFormat,
      width: numberWidth,
      allowEditing: true,
    }, {
      dataField: 'useful_life_tariff',
      caption: 'СПИ для тариф. Регулирования',
      dataType: 'number',
      width: 100,
      allowEditing: true,
      editorOptions: {
        onKeyPress: editInteger,
      },
    }, {
      dataField: 'residual_value_tariff',
      caption: 'Остаточная стоимость для тариф. Рег.',
      width: numberWidth,
      format: numberFormat,
      allowEditing: true,
    }, {
      dataField: 'algorithm_id',
      caption: 'Алгоритм',
      dataType: 'number',
      width: '120px',
      allowEditing: false,
      visible: false,
    }, {
      dataField: 'value_tariff_text',
      caption: 'Формула стоим. тариф. рег',
      dataType: 'string',
      width: '200px',
      allowEditing: false,
      visible: false,
    },
  ];

  return columns;
};

export const columnsAmortizationCalculation = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'main_asset_id',
    caption: 'ID ОС',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'department_id',
    caption: 'ID подразделения',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'type_row_id',
    caption: 'Тип строк',
    dataType: 'number',
    width: '80px',
    lookup: {
      valueExpr: 'id',
      displayExpr: 'name',
      popupWidth: '100px',
      dataSource: [{ id: 1, name: 'Факт' }, { id: 2, name: 'План' }, { id: 3, name: 'Итог' }],
    },
  }, {
    dataField: 'year',
    caption: 'Год',
    dataType: 'number',
    width: '100px',
  }, {
    dataField: 'period',
    caption: 'Период',
    dataType: 'string',
    width: '100px',
  }, {
    dataField: 'mvp_code',
    caption: 'Подразделение',
    dataType: 'string',
    width: '100px',
  }, {
    dataField: 'main_asset',
    caption: 'Основное средство',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'inventory_number',
    caption: 'Инвентарный номер',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'subnumber',
    caption: 'Субномер',
    dataType: 'number',
    width: '80px',
  }, {
    dataField: 'name',
    caption: 'Наименование',
    dataType: 'string',
    width: '200px',
    cellTemplate: 'longTextCellTemplate',
  }, {
    dataField: 'class_main_asset',
    caption: 'Класс ОС',
    dataType: 'number',
    width: '70px',
  }, {
    dataField: 'mvz',
    caption: 'МВЗ',
    dataType: 'string',
    width: '100px',
  },
  {
    dataField: 'internal_order',
    caption: 'Внутренний заказ',
    dataType: 'string',
    width: '100px',
  }, {
    dataField: 'group_amortization',
    caption: 'Группа амортизации',
    dataType: 'number',
    width: '70px',
  }, {
    dataField: 'cost_begin',
    caption: 'Первонач. стоимость на начало периода',
    dataType: 'number',
    width: numberWidth,
    format: numberFormat,
  }, {
    dataField: 'date_receipts',
    caption: 'Дата оприходования',
    dataType: 'date',
    width: '100px',
  }, {
    dataField: 'accounting_value',
    caption: 'Остаточная стоимость по бух. учету на начало года',
    dataType: 'number',
    width: numberWidth,
    format: numberFormat,
  }, {
    dataField: 'tariff_value',
    caption: 'Остаточная стоимость для тарифного регулирования на начало года',
    dataType: 'number',
    width: numberWidth,
    format: numberFormat,
  }, {
    dataField: 'accounting_useful',
    caption: 'Остаточный СПИ по бух. учету',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'tariff_useful',
    caption: 'Остаточный СПИ по тариф.рег.',
    dataType: 'number',
    width: '150px',
  }, {
    caption: 'Амортизация за ГГГГ год (факт). руб',
    dataField: 'amortization_by_year',
    columns: [{
      caption: 'по бух.учету в соответствии с ФСБУ',
      columns: [{
        dataField: 'accounting_thermal_city',
        caption: 'т/э СПб',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      }, {
        dataField: 'accounting_thermal_suburb',
        caption: 'т/э ЛО',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      }, {
        dataField: 'accounting_electricity',
        caption: 'э/э',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      }, {
        dataField: 'accounting_amortization',
        caption: 'всего',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      },
      ],
    }, {
      caption: 'для учета при тарифном регулировании',
      columns: [{
        dataField: 'tariff_thermal_city',
        caption: 'т/э СПб',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      }, {
        dataField: 'tariff_thermal_suburb',
        caption: 'т/э ЛО',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      }, {
        dataField: 'tariff_electricity',
        caption: 'э/э',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      }, {
        dataField: 'tariff_amortization',
        caption: 'всего',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        detail: true
      },
      ],
    },
    ],
  }, {
    dataField: 'change_value_period',
    caption: 'Изменение остаточной стоимости за период, руб',
    dataType: 'number',
    width: numberWidth,
    format: numberFormat,
  }, {
    dataField: 'accounting_value_end',
    caption: 'Остаточная стоимость по бух. учету на конец года',
    dataType: 'number',
    width: numberWidth,
    format: numberFormat,
  }, {
    dataField: 'tariff_value_end',
    caption: 'Остаточная стоимость на конец года  по тарифному регулированию',
    dataType: 'number',
    width: numberWidth,
    format: numberFormat,
  }, {
    dataField: 'accounting_algorithm_id',
    caption: 'Алгоритм для бух. учета',
    dataType: 'number',
    width: '150px',
    visible: false,
  }, {
    dataField: 'accounting_text',
    caption: 'Формула для бух. учета',
    dataType: 'string',
    width: '300px',
    visible: false,
  }, {
    dataField: 'tariff_algorithm_id',
    caption: 'Алгоритм по тариф.рег.',
    dataType: 'number',
    width: '150px',
    visible: false,
  }, {
    dataField: 'tariff_text',
    caption: 'Формула по тариф.рег.',
    dataType: 'string',
    width: '300px',
    visible: false,
  }];

export const columnsAmortizationCalculationHistory = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'user',
    caption: 'Пользователь',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'department_id',
    caption: 'ID подразделения',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'year',
    caption: 'Год',
    dataType: 'number',
    width: '100px',
  }, {
    dataField: 'period_str',
    caption: 'Период',
    dataType: 'string',
    width: '100px',
  }, {
    dataField: 'started_at',
    caption: 'Начала расчета',
    dataType: 'datetime',
    width: '120px',
  }, {
    dataField: 'finished_at',
    caption: 'Окончание расчета',
    dataType: 'datetime',
    width: '120px',
  }, {
    dataField: 'status',
    caption: 'Статус',
    dataType: 'string',
    width: '100px',
  }, {
    dataField: 'error_text',
    caption: 'Текст ошибки',
    dataType: 'string',
  }];

export const columnsAmortizationCalculationDetail = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'period',
    caption: 'Период',
    dataType: 'string',
    width: '100px',
  }, {
    caption: 'Амортизация по месяцам',
    dataField: 'amortization_by_year',
    columns: [{
      caption: 'по бух.учету в соответствии с ФСБУ',
      columns: [{
        dataField: 'accounting_thermal_city',
        caption: 'т/э СПб',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'accounting_thermal_suburb',
        caption: 'т/э ЛО',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'accounting_electricity_city',
        caption: 'э/э СПб',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'accounting_electricity_suburb',
        caption: 'э/э ЛО',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'accounting_value',
        caption: 'всего',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      },
      ],
    }, {
      caption: 'для учета при тарифном регулировании',
      columns: [{
        dataField: 'tariff_thermal_city',
        caption: 'т/э СПб',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'tariff_thermal_suburb',
        caption: 'т/э ЛО',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'tariff_electricity_city',
        caption: 'э/э СПб',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'tariff_electricity_suburb',
        caption: 'э/э ЛО',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      }, {
        dataField: 'tariff_value',
        caption: 'всего',
        dataType: 'number',
        width: numberWidth,
        format: numberFormat,
        summary: 'sum',
      },
      ],
    },
      { minWidth: 0 },
    ],
  }];

const editInteger = (e) => {
  var event = e.event,
    str = String.fromCharCode(event.keyCode);
  if (!/[0-9]/.test(str))
    event.preventDefault();
};

export const mvpLookupColumns = [
  { dataField: 'mvp_code', caption: 'Код', width: 150 },
  { dataField: 'name', caption: 'Название', width: 300 },
  { dataField: 'kod_direct', caption: 'id', width: 100, visible: false },
];

export const amortizationDistributionColumns = (lookupList, customEditTemplate, startDate, endDate) => {
  const columns = [
    {
      dataField: 'id',
      caption: 'ID',
      dataType: 'number',
      width: '100px',
      visible: false,
      allowEditing: false,
    },
    {
      dataField: 'department_id',
      caption: 'ID подразделения',
      dataType: 'number',
      width: '100px',
      visible: false,
      allowEditing: false,
    },
    {
      caption: 'Период действия',
      alignment: 'center',
      columns: [
        {
          dataField: 'start_date',
          caption: 'c',
          dataType: 'string',
          width: '250px',
          visible: true,
          alignment: 'center',
          editCellTemplate: startDate,
        },
        {
          dataField: 'end_date',
          caption: 'по',
          dataType: 'string',
          width: '250px',
          visible: true,
          alignment: 'center',
          editCellTemplate: endDate,
        },
      ],
    },
    {
      dataField: 'mvp_code',
      caption: 'МВП',
      name: 'mvp_code',
      width: '400px',
      allowEditing: true,
      editCellTemplate: customEditTemplate,
    },
    {
      caption: 'Распределение, %',
      alignment: 'center',
      columns: [
        {
          dataField: 'thermal_general',
          caption: 'т/э: общее',
          dataType: 'number',
          width: '180px',
          visible: true,
          allowEditing: false,
        },
        {
          dataField: 'thermal_city',
          caption: 'т/э: СПб',
          dataType: 'number',
          width: '150px',
          visible: true,
        },
        {
          dataField: 'thermal_suburb',
          caption: 'т/э: ЛО',
          dataType: 'number',
          width: '150px',
          visible: true,
        },
        {
          dataField: 'electricity_general',
          caption: 'э/э: общее',
          dataType: 'number',
          width: '180px',
          visible: true,
          allowEditing: false,
        },
        {
          dataField: 'electricity_city',
          caption: 'э/э: СПб',
          dataType: 'number',
          width: '150px',
          visible: true,
        },
        {
          dataField: 'electricity_suburb',
          caption: 'э/э: ЛО',
          dataType: 'number',
          width: '150px',
          visible: true,
        },
      ],
    },
  ];

  return columns;
};

export const columnsAmortizationExcluding = (startDateTemplate, mvpEditTemplate, showMvz, endDateTemplate) => {
  const columns = [
    {
      dataField: 'id',
      caption: 'ID',
      dataType: 'number',
      width: '100px',
      visible: false,
      allowEditing: false,
    },
    {
      caption: 'ID OC',
      dataField: 'main_asset_id',
      visible: false,
      allowEditing: false
    },
    {
      dataField: 'department',
      caption: 'Подразделение',
      dataType: 'string',
      width: '220px',
      editCellTemplate: mvpEditTemplate,
    },
    {
      dataField: 'mvz',
      caption: 'МВЗ',
      dataType: 'string',
      width: '120px',
      cellTemplate: showMvz,
    },
    {
      dataField: 'inventory_number',
      caption: 'Инвентарный номер',
      dataType: 'string',
      width: '150px',
      allowEditing: false,
    },
    {
      dataField: 'main_asset',
      caption: 'Основное средство',
      dataType: 'string',
      width: '100px',
      allowEditing: false,
    },
    {
      dataField: 'subnumber',
      caption: 'Субномер',
      dataType: 'number',
      width: '100px',
      allowEditing: false,
    },
    {
      dataField: 'name',
      caption: 'Название',
      width: '180px',
      allowEditing: false,
    },
    {
      dataField: 'class_main_asset',
      caption: 'Класс ОC',
      dataType: 'string',
      width: '100px',
    },
    {
      dataField: 'incoming_order',
      caption: 'Внутренний заказ',
      dataType: 'string',
      width: '100px',
    }, {
      caption: 'Распределение, %',
      alignment: 'center',
      columns: [{
        dataField: 'thermal_general',
        caption: 'т/э: общее',
        dataType: 'number',
        width: '90px',
        visible: true,
        allowEditing: false,
      }, {
        dataField: 'thermal_city',
        caption: 'т/э: СПб',
        dataType: 'number',
        width: '90px',
        visible: true,
      }, {
        dataField: 'thermal_suburb',
        caption: 'т/э: ЛО',
        dataType: 'number',
        width: '90px',
        visible: true,
      },
        {
          dataField: 'electricity_general',
          caption: 'э/э: общее',
          dataType: 'number',
          width: '90px',
          visible: true,
          allowEditing: false,
        },
        {
          dataField: 'electricity_city',
          caption: 'э/э: СПб',
          dataType: 'number',
          width: '90px',
          visible: true,
        },
        {
          dataField: 'electricity_suburb',
          caption: 'э/э: ЛО',
          dataType: 'number',
          width: '90px',
          visible: true,
        },
      ],
    },
    {
      caption: 'Период действия',
      columns: [
        {
          dataField: 'start_date',
          caption: 'с',
          dataType: 'string',
          width: '120px',
          alignment: 'right',
          editCellTemplate: startDateTemplate,
        }, {
          dataField: 'end_date',
          caption: 'по',
          dataType: 'string',
          width: '120px',
          alignment: 'right',
          editCellTemplate: endDateTemplate,
        },
      ],
    },
  ];
  return columns;
};

export const amortizationGroupsColumns = () => {
  const columns = [
    {
      dataField: 'name',
      caption: 'Амортизационная группа',
      dataType: 'string',
      width: '550px',
      allowEditing: true,
    },
    {
      dataField: 'code',
      caption: 'Код группы',
      dataType: 'number',
      width: '150px',
      allowEditing: true,
    },
    {
      dataField: 'spi',
      caption: 'СПИ, лет',
      dataType: 'string',
      width: '250px',
      allowEditing: false,
    }, {
      dataField: 'min_month',
      caption: 'Минимальный, мес',
      dataType: 'number',
      width: '250px',
      allowEditing: true,
    }, {
      dataField: 'max_month',
      caption: 'Максимальный, мес',
      dataType: 'number',
      width: '300px',
      allowEditing: true,
    }, {
      dataField: 'is_match',
      caption: 'Соотв. СПИ по бух учету',
      dataType: 'boolean',
      width: '300px',
      allowEditing: true,
    },
  ];

  return columns;
};

export const columnsAmortizationPlanWork = (cellTemplate, groupTemplate) => [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
    allowEditing: false,
  },
  {
    dataField: 'department_id',
    caption: 'ID подразделения',
    dataType: 'number',
    width: '100px',
    visible: false,
  },
  {
    dataField: 'main_asset_id',
    caption: 'ID ОС',
    dataType: 'number',
    width: '100px',
    visible: false,
  },
  {
    dataField: 'base_period',
    caption: 'Базовый период',
    visible: false,
    dataType: 'string',
    allowEditing: false,
    width: '100px',
  }, {
    dataField: 'department',
    caption: 'Подразделение',
    dataType: 'string',
    width: '350px',
    editCellTemplate: cellTemplate,
  },
  {
    dataField: 'inventory_number',
    caption: 'Инвентарный номер',
    dataType: 'string',
    width: '200px',
    allowEditing: false,
  }, {
    dataField: 'subnumber',
    caption: 'Субномер',
    dataType: 'number',
    width: '200px',
    allowEditing: false,
  }, {
    dataField: 'group_id',
    caption: 'Группа амортизации',
    dataType: 'number',
    width: '220px',
    editCellTemplate: groupTemplate,
  }, {
    dataField: 'work_name',
    caption: 'Наименование мероприятия',
    dataType: 'string',
    width: '350px'
  },{
    dataField: 'date_operation',
    caption: 'Плановая дата операции',
    dataType: 'date',
    format: 'dd.MM.yyyy',
    width: '220px',
    editorOptions: {
      displayFormat: 'dd.MM.yyyy',
    },
    serializationFormat: 'yyyy-MM-dd'
  }
  , {
    dataField: 'value',
    caption: 'Стоимость',
    dataType: 'string',
    alignment: 'right',
    width: '200px',
  }];

export const columnsPopupMainAsset = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'department_id',
    caption: 'ID подразделения',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'department',
    caption: 'Подразделение',
    dataType: 'string',
    width: '200px',
  }, {
    dataField: 'inventory_number',
    caption: 'Инвентарный номер',
    dataType: 'string',
    width: '250px',
  }, {
    dataField: 'main_asset',
    caption: 'Основное средство',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'class_main_asset',
    caption: 'Класс ОC',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'subnumber',
    caption: 'Субномер',
    dataType: 'number',
    width: '100px',
  }, {
    dataField: 'name',
    caption: 'Название',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'group_amortization',
    caption: 'Группа амортизации',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'date_receipts',
    caption: 'Дата оприходования',
    dataType: 'date',
    width: '150px',
  }, {
    dataField: 'useful_life',
    caption: 'Срок полезного использования по бух.учету',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'useful_life_tarif',
    caption: 'Срок полезного использования по тариф. рег.',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'created_at',
    caption: 'Дата создания',
    dataType: 'datetime',
    width: '150px',
  }, {
    dataField: 'updated_at',
    caption: 'Дата изменения',
    dataType: 'datetime',
    width: '150px',
  }, {
    dataField: 'mvp_code',
    caption: 'МВП',
    dataType: 'string',
    width: '150px',
  },
  {
    dataField: 'mvz',
    caption: 'МВЗ',
    dataType: 'string',
    width: '150px',
  },
];

export const mvzLookupColumns = [
  { dataField: 'mvp_code', caption: 'Код', width: 150 },
  { dataField: 'name', caption: 'Название', width: 300 },
  { dataField: 'kod_direct', caption: 'id', width: 100, visible: false },
  { dataField: 'mvz', caption: 'МВЗ', visible: true },
];
